import React from 'react';
import styled from 'styled-components';

const Container  = styled.div`
    padding: 5rem;
`;

const DEV = props => {

  return (
    <Container>
      <h3>Dev channel</h3>
    </Container>
  );
};

DEV.propTypes = {};

export default DEV;
